export const FRANCE_TIME_ZONE = 'Europe/Paris';

const PARIS_DATE_PARTS_FORMATTER = new Intl.DateTimeFormat('en-CA', {
  timeZone: FRANCE_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const toValidDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
};

export const formatDateInParis = (value, {
  locale = 'fr-FR',
  fallback = '-',
  options = {},
} = {}) => {
  if (value === null || value === undefined || value === '') return fallback;
  const date = toValidDate(value);
  if (!date) return String(value);
  return date.toLocaleDateString(locale, {
    timeZone: FRANCE_TIME_ZONE,
    ...options,
  });
};

export const formatDateTimeInParis = (value, {
  locale = 'fr-FR',
  fallback = '-',
  options = {},
} = {}) => {
  if (value === null || value === undefined || value === '') return fallback;
  const date = toValidDate(value);
  if (!date) return String(value);
  return date.toLocaleString(locale, {
    timeZone: FRANCE_TIME_ZONE,
    ...options,
  });
};

export const getDatePartsInParis = (value = new Date()) => {
  const date = toValidDate(value);
  if (!date) return null;

  const parts = PARIS_DATE_PARTS_FORMATTER.formatToParts(date);
  const year = Number(parts.find((part) => part.type === 'year')?.value);
  const month = Number(parts.find((part) => part.type === 'month')?.value);
  const day = Number(parts.find((part) => part.type === 'day')?.value);

  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return null;
  }

  return {
    year,
    month,
    day,
  };
};

export const toDateInputValueInParis = (value = new Date()) => {
  const parts = getDatePartsInParis(value);
  if (!parts) return '';
  return `${String(parts.year).padStart(4, '0')}-${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
};

export const formatMonthYearInParis = (year, month, locale = 'fr-FR') => {
  const safeYear = Number(year);
  const safeMonth = Number(month);
  if (!Number.isFinite(safeYear) || !Number.isFinite(safeMonth) || safeMonth < 1 || safeMonth > 12) {
    return '';
  }

  // Use UTC noon to avoid edge cases around timezone day rollovers.
  const anchor = new Date(Date.UTC(safeYear, safeMonth - 1, 1, 12, 0, 0));
  return anchor.toLocaleDateString(locale, {
    timeZone: FRANCE_TIME_ZONE,
    month: 'long',
    year: 'numeric',
  });
};